import useCurrentLoginUserInfo from '@/hooks/useCurrentLoginUserInfo';
import { useEffect, useState } from 'react';

/**
 * @description: 判断菜单权限
 * @author: KaifengLi
 * @param {string} pageName
 * @version: v2.21.0
 * @Date: 2024-08-16 15:13:36
 */
export const useMenuPer = (pageName?: string): any => {
  const [userInfo] = useCurrentLoginUserInfo();
  const [permissionData, setPermissionData] = useState<any>({});

  useEffect(() => {
    if (userInfo?.resourceCodes) {
      transFormCodes();
    }
  }, [userInfo]);

  // 根据localCodeNames结构组织权限树
  const transFormCodes = () => {
    const codeData = userInfo.resourceCodes
      .reduce((acc: Record<string, any>, curr: string) => {
        acc[curr] = true; // 或者设置其他值
        return acc;
      }, {});
    setPermissionData(codeData);
  };

  return pageName ? permissionData[pageName] || {} : permissionData;
};

export default useMenuPer;
